import { entityFieldIsEmpty } from "./entity-field-is-empty";
export var entityFieldIsValid = function (value, field) {
  var isValid = true;
  // if the field is required, check if it's empty
  if (field.required) {
    isValid = !entityFieldIsEmpty(value, field);
  }
  // here, we'd probably add other validation checks based on the field type
  // let's just stick to the required check for now
  return isValid;
};